import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

// Spinner component
const Spinner = ({ text }) => (
  <div style={{ textAlign: "center", marginTop: "10px" }}>
    <div className="spinner" />
    {text && <p>{text}</p>}
  </div>
);

const DropzoneUpload = ({
  onUpload,
  onRemove,
  acceptedExtensions = [],
  allowMultiple = false,
}) => {
  const [file, setFile] = useState(null);
  const [uploadKey, setUploadKey] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const acceptTypes =
    acceptedExtensions.length > 0
      ? acceptedExtensions.reduce((acc, ext) => {
          const mimeType =
            ext === ".pdf"
              ? "application/pdf"
              : ext === ".jpg" || ext === ".jpeg"
              ? "image/jpeg"
              : ext === ".png"
              ? "image/png"
              : "application/octet-stream";
          acc[mimeType] = acc[mimeType] || [];
          acc[mimeType].push(ext);
          return acc;
        }, {})
      : undefined;

  const onDrop = async (acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    setFile(selectedFile);

    if (onUpload) {
      setUploading(true);
      const key = await onUpload(selectedFile);
      console.log("key", key);
      setUploadKey(key);
      setUploading(false);
    }
  };

  const removeFile = async () => {
    if (onRemove && uploadKey) {
      setDeleting(true);
      await onRemove(uploadKey);
      setDeleting(false);
    }
    setFile(null);
    setUploadKey(null);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: allowMultiple,
    accept: acceptTypes,
  });

  return (
    <div>
      {(uploading || deleting) && (
        <Spinner text={uploading ? "Please Wait..." : "Removing..."} />
      )}

      {!file && !uploading ? (
        <div
          {...getRootProps()}
          style={{
            border: "2px dashed #aaa",
            padding: "20px",
            textAlign: "center",
            background: isDragActive ? "#e0f7fa" : "#f9f9f9",
            borderRadius: "10px",
            cursor: "pointer",
          }}
        >
          <input {...getInputProps()} />
          <p>
            {isDragActive
              ? "Drop the file here ..."
              : "Drag & drop a file or click to select"}
          </p>
        </div>
      ) : null}

      {file && !deleting && !uploading ? (
        <div
          style={{
            border: "1px solid #ccc",
            padding: "8px",
            marginTop: "10px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{file.name}</span>
          <button
            onClick={removeFile}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "18px",
              cursor: "pointer",
              marginLeft: "10px",
            }}
            title="Remove"
          >
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default DropzoneUpload;
